import { AbacProvider } from "react-abac";
import { useEffect, useState } from "react";
import { useAuth } from "@/hooks/authentication";
import { RulesMap } from "./rulesMap";
import { Permission, Role } from "./types";

import { Lockr } from "@/common/Lockr";
import { StorageKeys } from "@/common/constants/storageKeys";
import { tryGetRolesFromJwt } from "@/common/authentication/jwtDecoder";

export interface User {
	id: string;
	roles: Role[];
	permissions: Permission[];
}

export const AuthorizationProvider = ({ children }: any) => {
	const auth = useAuth();
	const [user, setUser] = useState<User>({
		id: "",
		roles: [],
		permissions: [],
	});

	useEffect(() => {
		if (!auth.isLogged) {
			return;
		}

		const roles = tryGetRolesFromJwt(Lockr.get(StorageKeys.TokenId)) as Role[];

		setUser({
			id: auth.userId,
			roles: roles,
			permissions: [],
		});
	}, [auth]);

	return (
		<AbacProvider
			rules={RulesMap}
			user={user}
			roles={user.roles}
			permissions={user.permissions}
		>
			{children}
		</AbacProvider>
	);
};
